<template>
    <div class="question-container">
        <div v-for="questionItem in sortedQuestions" :key="questionItem.id" class="questionList">
            <div class="id" :title="questionItem.id" :class="[getQuestionTypeClass(questionItem.question_type), { blackNWhite: isExcluded(questionItem) }]"></div>
            <div class="description">{{questionItem.description ? questionItem.description : "&nbsp;" }}</div>
            <div class="help_text">{{ questionItem.help_text ? questionItem.help_text : "&nbsp;" }}</div>
            <div class="actions">
                <button @click="editQuestion(questionItem)" class="btn btn-icon" title="Modifier question"><i class="bi bi-pencil-fill"></i></button>
                <button v-if="!isLocked" @click="deleteQuestion(questionItem)" class="btn btn-icon btn-danger" title="Supprimer"><i class="bi bi-trash3-fill"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
// import draggable from 'vuedraggable'
import '../../assets/styles/base.css'
/* import '../../assets/styles/referential-question-editor.css' */

export default {
    name: "ReferentialQuestionEditor",
    props: [ 'criteria_id', 'filterIsActive' ],
    components: {
        // draggable,
    },
    computed: {
        ...mapState("referential", ["selectedReferential", "criteriaTree", "canEditList", "questionTree"]),
        ...mapState("auth", []),
        ...mapGetters("referential", ["fetchQuestionCriteria", 'isReferentialLocked', 'sanitizeText']),
        isLocked() {
            return this.isReferentialLocked(this.selectedReferential)
        },
        sortedQuestions() {
        if (!this.questionTree) return [];

        // que les questions qui ont le bon 'criteria_id'.
        let questions = this.questionTree.filter(
            q => q.criteria_id === this.criteria_id
        );

        if (this.filterIsActive) {
            return questions.filter(q => {
            const hasBlackValue = q.question_values && 
                                q.question_values['0'] && 
                                q.question_values['0'].possible_text === "Black";
            const hasLimits = q.question_limits && 
                            q.question_limits['0'] && 
                            q.question_limits['0'].sign.length > 0 && 
                            q.question_limits['0'].limit.length > 0;
            return hasBlackValue || hasLimits;
        });
    }
        return questions;
    },
    },
    /* mounted() {
        // this.question = this.fetchQuestionCriteria(this.criteria_id)
        // //console.log("We got a question for criteria? ", this.criteria_id, this.question)
    }, */
    methods: {
        getQuestionTypeClass(typeQ) {
            if (typeQ === "QUALITATIVE") {
                return "bi bi-award-fill";
            } else if (typeQ === "QUANTITATIVE-VALUE" || typeQ === "FORMULA") {
                return "bi bi-bar-chart-fill";
            }
            return "";
        },
        isExcluded(question){
            ////console.log("IsExcluded :",question);
        if(!question)return false;
            const hasQuantitativeMatch = question.question_limits && 
            question.question_limits['0'] && 
            question.question_limits['0'].sign.length > 0 && 
            question.question_limits['0'].limit.length > 0;
            
            const hasQualitativeMatch = question.question_values && 
            question.question_values['0'] && 
            question.question_values['0'].possible_text === "Black";
            return hasQuantitativeMatch || hasQualitativeMatch;
        },
        editQuestion(question) {
            /* this.$store.commit("referential/callerSetMutation", []) */
            this.$store.commit("referential/makeQuestionActiveMutation", question)
            this.toggleQuestionModalOpen()
            
        },
        deleteQuestion(question) {
            // //console.log("Deleting:", question)
            // //console.log("trying to delete question ", question)
            this.$store.commit("referential/returnConfirmationObjectMutation", { 
                id: question.id, 
                type: "delete-question",
                title: "Suppression",
                message: "Êtes-vous sûr de vouloir supprimer cette question?"
            })
            // this.$store.dispatch("referential/questionDelete", {id: question.id})
        },
        toggleQuestionModalOpen() {
            if(this.selectedReferential > 0) {
                // //console.log("We have open?", this.canEditList)
                this.$store.commit("referential/toggleQuestionModal", !this.canEditList.questionEditorOpen)
            } else {
                this.$store.commit("referential/toggleQuestionModal", false)
            }
        },
        // updateQuestionOrder() {
        //     //console.log("New question order:", this.sortedQuestions)
        // },
    },
    
};
</script>


<style scoped>

.questionList {
    margin: 0px 0 0 40px;
    padding: 0 0 0 10px;
    background: #58585820;
    border-radius: 6px;
    border-left: 3px solid var(--primary-color);
    /* border-right: 3px solid #e8182d86;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05); */
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    word-break: break-word;
}
.questionList div {
    display: flex;
    align-items: center;
    justify-content: center;
    /* margin-right: 15px; */
    padding: 8px 12px;
    border-radius: 4px;
    text-align: center;
}
.questionList:hover {
    /* transform: translateX(5px); */
    /* box-shadow: 0 4px 8px rgba(253,26,50,0.1); */
    background-color: var(--question-color);
}
.questionList .id {
    width: 5%;
    background-color: var(--bg-color);
    justify-content: center;
    font-weight: bold;
    font-size: 0.9em;
}
.questionList .description {
    flex: 2;
    background: none;
    text-align: left;
    color: #333;
}
.questionList .help_text {
    flex: 1;
    background: none;
    font-size: 0.9em;
    color: #666;
    font-style: italic;
}
.questionList .reference {
    font-weight: 500;
    width: 8%;
    color: var(--primary-color);
}
.questionList .title {
    width: 65%;
    color: #333333;
}
 /* .questionList .actions {
    width: 10%;
    min-width: 100px;
    gap: 4px;
    background: none;
    justify-content: flex-end;
    padding: 0;
}
.questionList .actions button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #fefefe;
    border: 1px solid #585858;
    padding: 4px 8px;
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.2s ease;
    font-size: 0.9em;
    height: 28px;
    width: 28px;
    margin: 3px;
    color: #e53134;
}
.questionList .actions button:hover {
    background-color: #5858581b;
    color: #ffffff;
}
.questionList:active {
    cursor: grabbing;
} */
.actions {
    display: flex;
    gap: 8px;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s;
}

.questionList:hover .actions,
.actions:focus-within {
    opacity: 1;
    pointer-events: auto;
}

.btn {
    border: none;
    border-radius: 4px;
    padding: 6px 12px;
    cursor: pointer;
    transition: all 0.2s;
    font-weight: 500;
}

.btn-icon {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #f8f9fa;
    font-size: 18px;
    padding: 0;
}
/* 
.btn-icon:hover {
    background: #e9ecef;
}

.btn-danger:hover {
    background: rgba(220, 53, 69, 0.1);
} */

button {
    background-color: var(--hover-bg);
    color: var(--text-color);
}

button:hover {
    color: var(--primary-color);
}
.criteria-children {
    margin: 0;
    padding: 0;
}

.criteria-questions {
    /* padding: 8px 16px; */
    border-radius: 8px;
    max-width: 100%;
}

.questionList >.blackNWhite{
    background: black;
    color: white;
}

</style>